export const state = {
  dateLocale: ''
}

export const getters = {
  dateLocale (state) {
    return state.dateLocale
  },
}

export const mutations = {
  SET_DATE_LOCALE (state, dateLocale) {
    state.dateLocale = dateLocale
  },
}

export const actions = {
  setDateLocale({ commit }, locale) {
    return commit('SET_DATE_LOCALE', locale)
  },
}
